import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "p-1 whitespace-nowrap"
};
const _hoisted_2 = {
  key: 0,
  class: "text-right"
};
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center text-xs"
};
const _hoisted_4 = {
  class: "p-1 flex items-center"
};
const _hoisted_5 = {
  class: "p-1 text-right"
};
const _hoisted_6 = {
  class: "p-1 text-right"
};
const _hoisted_7 = {
  class: "p-1 text-right"
};
const _hoisted_8 = {
  class: "p-1 text-right"
};
const _hoisted_9 = {
  class: "p-1"
};
const _hoisted_10 = {
  class: "p-1"
};
const _hoisted_11 = {
  class: "p-1 text-right"
};
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import { ColorEnum } from "@/modules/vue/enums";
import Icon from "@/modules/vue/components/Icon.vue";
import Marker from "@/modules/competitions/components/divisions/Table/Marker.vue";
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'TableRow',
  props: {
    stat: null,
    promotions: null,
    index: null,
    relegated: {
      type: Boolean
    },
    promoted: {
      type: Boolean
    },
    winner: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const promotion = computed(() => props.promotions.find(p => p.isForRank(props.index + 1)));
    const colorMap = generateColorMap({
      bg: 500
    });
    const markerColumnClasses = computed(() => {
      if (promotion.value && promotion.value.colorInTable && promotion.value.showInTable) {
        return colorMap[promotion.value.colorInTable];
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("tr", null, [_createElementVNode("td", {
        class: _normalizeClass(_unref(markerColumnClasses))
      }, null, 2), _createElementVNode("td", _hoisted_1, [__props.stat.rank ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.stat.rank), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_3, "●"))]), _createElementVNode("td", _hoisted_4, [_createVNode(EntityLink, {
        entity: __props.stat.team
      }, null, 8, ["entity"]), __props.promoted ? (_openBlock(), _createBlock(Marker, {
        key: 0,
        class: "ml-1",
        color: _unref(ColorEnum).Green
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.AngleUp,
          size: "1rem"
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["color"])) : _createCommentVNode("", true), __props.relegated ? (_openBlock(), _createBlock(Marker, {
        key: 1,
        class: "ml-1",
        color: _unref(ColorEnum).Red
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.AngleDown,
          size: "1rem"
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["color"])) : _createCommentVNode("", true), __props.winner ? (_openBlock(), _createBlock(Marker, {
        key: 2,
        class: "ml-1",
        color: _unref(ColorEnum).Gold
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.Crown,
          size: "1rem"
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["color"])) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_5, _toDisplayString(__props.stat.matches), 1), _createElementVNode("td", _hoisted_6, _toDisplayString(__props.stat.wins), 1), _createElementVNode("td", _hoisted_7, _toDisplayString(__props.stat.draws), 1), _createElementVNode("td", _hoisted_8, _toDisplayString(__props.stat.loses), 1), _createElementVNode("td", _hoisted_9, _toDisplayString(__props.stat.goals) + ":" + _toDisplayString(__props.stat.goals_against), 1), _createElementVNode("td", _hoisted_10, _toDisplayString(__props.stat.goals - __props.stat.goals_against), 1), _createElementVNode("td", _hoisted_11, _toDisplayString(__props.stat.points), 1)]);
    };
  }
});